// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import RelicChest from "../prefabs/RelicChest";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnAudio from "../core/prefabs/BtnAudio";
import BtnChestPlay from "../prefabs/BtnChestPlay";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { SceneData, TransitionPoint } from '../rooting';
import UIButton from '../core/components/UIButton';
import { RunSettings } from '../level/RunSettingsHandler';
import { RelicNameValues } from '../level/relics/relic';
import { GameDataHandler } from '../GameDataHandler';
import TestChunkPlatformCollision from '../level/chunks/test/TestChunkPlatformCollision';
/* END-USER-IMPORTS */

export default class RelicSelect extends BaseScene {

  constructor() {
    super("RelicSelect");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg_sky_jpg_19
    this.add.image(0, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_18
    this.add.image(100, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_17
    this.add.image(200, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_16
    this.add.image(300, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_15
    this.add.image(400, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_14
    this.add.image(500, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_13
    this.add.image(600, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_12
    this.add.image(700, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_11
    this.add.image(800, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_10
    this.add.image(900, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_9
    this.add.image(1000, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_8
    this.add.image(1100, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_7
    this.add.image(1200, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_6
    this.add.image(1300, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_5
    this.add.image(1400, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_4
    this.add.image(1500, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_3
    this.add.image(1600, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_2
    this.add.image(1700, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_1
    this.add.image(1800, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_1
    this.add.image(1900, 384, "game-all", "bg-sky.jpg");

    // tile_sea_png
    this.add.image(960, 725, "game-all", "tile-sea.png");

    // tile_clouds_2_png
    this.add.image(1555, 317, "game-all", "tile-clouds-2.png");

    // tile_clouds_1_png
    this.add.image(434, 430, "game-all", "tile-clouds-1.png");

    // relicChest
    const relicChest = new RelicChest(this, 960, 384);
    this.add.existing(relicChest);

    // btnBack
    const btnBack = new BtnBack(this, 72, 76);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1854, 76);
    this.add.existing(btnAudio);

    // btnChestPlay
    const btnChestPlay = new BtnChestPlay(this, 1385, 651);
    this.add.existing(btnChestPlay);

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.relicChest = relicChest;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.btnChestPlay = btnChestPlay;

    this.events.emit("scene-awake");
  }

  private relicChest!: RelicChest;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private btnChestPlay!: BtnChestPlay;

  /* START-USER-CODE */
  private sceneData!: SceneData;
  private relicStartY: number = 0;
  private relicStartScale: number = 0;
  private unlockedRelics: RelicNameValues[] | undefined;

  public init(data: SceneData): void {
    this.sceneData = data;

    super.init(data);
  }

  public preload(): void {
    this.cache.json.remove('asset-pack-map');
    this.textures.remove('map');
  }

  public create() {
    this.editorCreate();

    this.relicStartY = this.relicChest.y;
    this.relicStartScale = this.relicChest.scale;

    // this.relicChest.on(RelicChest.events.RelicChosen, this.onRelicChosen, this);
    this.btnChestPlay.on(UIButton.events.clicked, this.onBtnChestPlay, this);

    this.btnBack.on(UIButton.events.clicked, this.back, this);

    this.unlockedRelics = this.game.registry.get(GameDataHandler.keys.CollectedRelics) as RelicNameValues[];
    let newRelics = this.game.registry.get(GameDataHandler.keys.NewRelics) as RelicNameValues[];
    this.relicChest.showRelics(this.unlockedRelics, newRelics, this.sceneData.runSettings?.activeRelics ?? [], true, false);

    this.relicChest.scale = 0.8;
    this.relicChest.y = this.relicChest.y + 80;

    this.add.tween({
      targets: this.relicChest,
      scaleX: this.relicStartScale,
      scaleY: this.relicStartScale,
      y: this.relicStartY,
      duration: 1500,
      delay: 600,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.btnChestPlay.scale = 0;
    this.add.tween({
      targets: this.btnChestPlay,
      scale: 1,
      duration: 500,
      delay: 1500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  protected onBtnChestPlay() {
    let selectedRelic = this.relicChest.SelectedRelic;
    this.onRelicChosen(selectedRelic);
  }

  protected onRelicChosen(relicName: RelicNameValues | undefined) {
    let relics = relicName ? [relicName] : [];
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    this.sceneData.runSettings.activeRelics = relics;
    app.gotoNextScene(this, TransitionPoint.RelicSelectEnd, this.sceneData);
  }

  protected back() {
    if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
    if (this.relicChest.SelectedRelic && this.unlockedRelics && this.unlockedRelics.includes(this.relicChest.SelectedRelic))
      this.sceneData.runSettings.activeRelics = [this.relicChest.SelectedRelic];
    else this.sceneData.runSettings.activeRelics = [];

    app.gotoNextScene(this, TransitionPoint.RelicSelectBack, this.sceneData);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
